import { Flag } from 'lucide-react';

interface StepBannerProps {
  tone: 'final' | 'optional';
  label: string;
  text: string;
}

const TONES = {
  final: 'border-[#5CB891] bg-[#5CB891]/10 text-[#5CB891]',
  optional: 'border-gray-300 bg-gray-100 text-gray-500'
} as const;

export function StepBanner({ tone, label, text }: Readonly<StepBannerProps>) {
  return (
    <div
      className={`flex items-center gap-3 border-l-4 px-4 py-3 ${TONES[tone]}`}
    >
      <Flag className="h-5 w-5 shrink-0" aria-hidden="true" />
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest">
          {label}
        </p>
        <p className="text-sm font-bold text-gray-800">{text}</p>
      </div>
    </div>
  );
}
